import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type PreferencesState = {
  flowExpandedView: boolean;
  sessionExpandedView: boolean;
};

export const usePreferencesStore = create<
  PreferencesState & { setPreferences: (change: Partial<PreferencesState>) => void }
>()(
  persist(
    (set) => ({
      flowExpandedView: false,
      sessionExpandedView: false,
      setPreferences: (change) => set((state) => ({ ...state, ...change })),
    }),
    {
      name: 'preferences',
    },
  ),
);
